import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import HistoryParametersFilterboxView from './HistoryParametersFilterboxView';

import { 
  setDeviceDocumentFilter,
  setDeviceDocumentColumnFilter 
} from '../../actions/documents';

class HistoryParametersFilterbox extends React.Component {
  render() {
    return (
      <HistoryParametersFilterboxView
        documentSoftenerFilter={this.props.documentSoftenerFilter}
        documentSuperiorFilter={this.props.documentSuperiorFilter}
        setDeviceDocumentFilter={this.props.setDeviceDocumentFilter}
        setDeviceDocumentColumnFilter={this.props.setDeviceDocumentColumnFilter}
        deviceDocument={this.props.deviceDocument}
      />
    );
  }
}

const mapState = state => ({
  documentSoftenerFilter: state.softenerParametersFilter,
  documentSuperiorFilter: state.superiorParametersFilter,
});

const mapDispatch = dispatch => {
  return {
    setDeviceDocumentFilter: (documentType, name, deviceType) =>
      dispatch(setDeviceDocumentFilter(documentType, name, deviceType)),
    setDeviceDocumentColumnFilter: (documentType, name, deviceType) =>
      dispatch(setDeviceDocumentColumnFilter(documentType, name, deviceType)),
  };
};

HistoryParametersFilterbox.propTypes = {
  deviceDocument: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSoftenerFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSuperiorFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  setDeviceDocumentFilter: PropTypes.func.isRequired,
  setDeviceDocumentColumnFilter: PropTypes.func.isRequired,
};

export default connect(mapState, mapDispatch)(HistoryParametersFilterbox);



// WEBPACK FOOTER //
// ./src/components/HistoryParameters/HistoryParametersFilterbox.js